import './custom.scss';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');

// Server-rendered page: hydrate the existing markup instead of replacing it,
// otherwise the SSR content is wiped and the page flickers until the client fetch completes.
// (public/index.html leaves an <!--ssr-outlet--> comment, so only check for elements)
if (container.firstElementChild)
{
  ReactDOM.hydrateRoot(container, <App />);
}
else
{
  ReactDOM.createRoot(container).render(<App />);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
